module.exports = __webpack_public_path__ + "static/media/Let it Snow Bingo.43859b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Let it Snow Bingo.png
// module id = 674
// module chunks = 0